<template>
    <div
        class="reading-content"
        :visible.sync="detailVisible"
        v-if="detailVisible"
    >
        <div class="reading-title">老年大学招生学员须知</div>
        <div
            class="reading-main"
            v-html='reading'
        >

        </div>
        <div
            class="actionButton clearfix"
            style="text-align:center;"
        >
            <el-button
                type="primary"
                size="medium"
                style="margin:30px auto;"
                @click="agree"
            >同意以上协议并保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Reading",
    props: ["showflag"],
    data() {
        return {
            detailVisible: this.showflag,
            reading: "",
        };
    },
    computed: {},
    methods: {
        agree: function () {
            this.detailVisible = false;
            this.$global.isagree = true;
            this.$emit("hidden", false);
            window.sessionStorage.setItem("isagree", false);
        },
        async getAgreement() {
            let me = this;
            let res = await me.$userService.getAgreement({ planType: "1" });
            if (res && res["success"]) {
                me.reading = res.content;
            }
        },
    },
    created: async function () {
        this.$global.activeMenu = "2-2"; //不激活左侧
        // this.getAgreement();
    },
    mounted() {
        this.getAgreement();
    },
    watch: {
        showflag(val) {
            this.detailVisible = val;
        },
    },
};
</script>
<style lang="scss" scoped>
.reading-content {
    padding: 30px;
    .reading-title {
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        color: #535b6c;
    }
    .reading-main {
        font-size: 16px;
        padding: 20px;
        border: 1px solid #d0d4dc;
        color: #545b6d;
        margin: 20px 0;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/register/children/Reading.vue